<template>
  <div id="fab">
    <v-speed-dial
      v-model="fab"
      fixed
      bottom
      right
      direction="top"
      transition="slide-y-reverse-transition"
    >
      <v-btn
        slot="activator"
        color="red"
        dark
        fab
        hover
        v-model="fab"
      >
        <v-icon>add_location</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="green"
      >
        <v-icon>panorama_horizontal</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="indigo"
      >
        <v-icon>timeline</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="red"
        @click="toggle_dialog_add_point"
      >
        <v-icon>place</v-icon>
      </v-btn>
    </v-speed-dial>
  </div>
</template>
<style scoped>
</style>
<script>
export default {
  data () {
    return {
      fab: false
    }
  },
  methods: {
    toggle_dialog_add_point () {
      this.$store.commit('toggleDialogAddPoint')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/actionButton.vue